//根据代码来判断 收货地、发货地、品名
const dictFmt = function(val){
    switch(val){
      case 1:
          return '发货地'
          break
      case 2:
          return '收货地'
          break
      case 3:
          return '品名'
          break
    }
}
const returnFloat = function(value){
	var s=value.toString().split(".");
	if(s.length==1){
		value=value.toString()+".00";
		return value;
	}
	if(s.length>1){
		if(s[1].length<2){
			value=value.toString()+"0";
		}
		return value;
	}
}
export {
    dictFmt,
    returnFloat
}